import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconEmail24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M0.75 17.3337V6.66675C0.75 6.25253 1.08579 5.91675 1.5 5.91675C1.91421 5.91675 2.25 6.25253 2.25 6.66675V17.3337C2.25008 17.8457 2.45082 18.3346 2.80371 18.6931C3.15625 19.0511 3.6317 19.2498 4.125 19.2498H19.875C20.3683 19.2498 20.8437 19.0511 21.1963 18.6931C21.5492 18.3346 21.7499 17.8457 21.75 17.3337V6.66675C21.75 6.25253 22.0858 5.91675 22.5 5.91675C22.9142 5.91675 23.25 6.25253 23.25 6.66675V17.3337C23.2499 18.2359 22.8971 19.1033 22.2656 19.7449C21.6336 20.3869 20.774 20.7498 19.875 20.7498H4.125C3.22605 20.7498 2.36637 20.3869 1.73438 19.7449C1.10294 19.1033 0.750085 18.2359 0.75 17.3337Z"
      fill="currentColor"
    />
    <path
      d="M19.875 3.25C20.7739 3.25 21.6336 3.61287 22.2656 4.25488C22.8972 4.89651 23.25 5.76461 23.25 6.66699C23.2499 6.92368 23.1181 7.1623 22.9014 7.2998L13.793 13.0781C13.2563 13.4188 12.6349 13.5996 12 13.5996C11.365 13.5996 10.7438 13.418 10.207 13.0771V13.0781L1.09863 7.2998C0.881858 7.1623 0.750111 6.92368 0.75 6.66699C0.75 5.76461 1.10278 4.89651 1.73438 4.25488C2.36637 3.61287 3.22606 3.25 4.125 3.25H19.875ZM4.125 4.75C3.63156 4.75 3.15628 4.94945 2.80371 5.30762C2.54124 5.57426 2.36312 5.91259 2.28906 6.2793L11.0107 11.8115L11.124 11.8779C11.3938 12.0237 11.6946 12.0996 12 12.0996C12.3489 12.0996 12.6917 12.0004 12.9893 11.8115L21.71 6.2793C21.6359 5.91267 21.4587 5.57422 21.1963 5.30762C20.8437 4.94945 20.3684 4.75 19.875 4.75H4.125Z"
      fill="currentColor"
    />
  </SvgIcon>
));
IconEmail24.displayName = 'IconEmail24';
